import { render } from "./md-tablet-portrait.vue?vue&type=template&id=2f976375"
import script from "./md-tablet-portrait.vue?vue&type=script&lang=js"
export * from "./md-tablet-portrait.vue?vue&type=script&lang=js"
script.render = render

export default script